import React from "react";
import "./Loader.css";
import rdaLogo from "../../asset/Loading Icon.png";

const MainLoader = () => {
  return (
    <div className="h-screen w-full flex justify-center items-center bg-[#66666640]">
      <div className=" relative w-[100px] h-[100px]">
        <div className="circle"></div>
        <img
          className="w-[88px] absolute top-1.5 left-1.5"
          src={rdaLogo}
          alt="Static"
        />
      </div>
    </div>
  );
};

export default MainLoader;
